import { DEVIATION_TYPE, type DeviationType } from "../../../messages"
import { ANGLE_DEVIATION_STAGES, STAGE } from "../../stages"

// TODO: Move common stages to a shared module
export const ANGLE_DEVIATION_MESSAGE_MAP: Record<
  (typeof ANGLE_DEVIATION_STAGES)[number],
  DeviationType
> = {
  [STAGE.FACE_PITCH_ANGLE_DEVIATION]: DEVIATION_TYPE.PITCH,
  [STAGE.FACE_YAW_ANGLE_DEVIATION]: DEVIATION_TYPE.YAW,
  [STAGE.FACE_ROLL_ANGLE_DEVIATION]: DEVIATION_TYPE.ROLL,
}
